const _setSrc = (src, _path) => {
  if (!src.includes('http://') && !src.includes('https://') && _path) {
    return _path + src
  } else {
    return src
  }
}
export default class LoadResource {
  preload = null
  files = []
  srcArr = []
  enterFiles = []
  state = 'entry'
  db = null
  constructor(options = {}) {
    this.progress_callback = options.progress_callback || null
    this.error_callback = options.error_callback || this.__handleError
    this.complete_callback = options.complete_callback || this.__handleComplete
    this.fileloaded_callback = options.fileloaded_callback || null
  }
  init() {
    this.preload = new createjs.LoadQueue(true)
    //注意加载音频文件需要调用如下代码行
    createjs.Sound.registerPlugins([createjs.HTMLAudioPlugin])
    // this.preload.installPlugin(createjs.Sound)
    //为preloaded添加整个队列变化时展示的进度事件
    // this.preload.on("progress", this.__handleProgress, this)
    //为preloaded添加当队列完成全部加载后触发事件
    this.preload.on('complete', e => {
      if (this.state === 'entry' && this.files.length) {
        this.download({
          files: this.files,
        })
      } else {
        this.files = []
        this.progress_callback({
          progress: 1,
        })
        setTimeout(e => this.complete_callback(e), 20)
      }
    })
    this.preload.on(
      'error',
      e => {
        this.__handleError(e)
      },
      this
    )
    this.preload.on(
      'fileload',
      e => {
        this.__handleFileload(e)
      },
      this
    )
    this.preload.on('fileprogress', this.__handleFileProgress, this)
    //设置最大并发连接数  最大值为10
    this.preload.setMaxConnections(10)
  }
  destroy() {
    // this.preload && this.preload.destroy()
  }
  download({ files, state = 'res', root_path = '' }) {
    if (!files || !files.length) return
    this.state = state
    // this.preload && this.preload.close()
    // this.preload && this.preload.removeAll()
    this.srcArr = []
    this.enterFiles = []
    let _files
    let isLoaded = false
    if (typeof files == 'string') {
      _files = {
        id: _setSrc(files, root_path),
        src: _setSrc(files, root_path),
        root_path: root_path,
      }
      isLoaded = this.preload.getItem(_setSrc(files, root_path))
      if (!isLoaded) {
        this.showDownloading && this.showDownloading()
        this.preload.loadFile(_files, true, root_path)
        this.enterFiles.push(_files)
      } else {
        this.complete_callback()
      }
    } else {
      _files = files.map(item => {
        return {
          id: _setSrc(item.src, item.root_path),
          src: _setSrc(item.src, item.root_path),
          root_path: item.root_path || root_path,
        }
      })
      isLoaded = _files.every(item => {
        return this.preload.getItem(item.id)
      })
      if (!isLoaded) {
        this.showDownloading && this.showDownloading()
        this.enterFiles = _files
        this.preload.loadManifest(_files, true, root_path)
      } else {
        this.complete_callback()
      }
    }
  }
  __handleFileload(event) {
    if (this.state === 'entry') {
      this.__traverse(
        event.result,
        event.item.root_path || event.item.path || ''
      )
    }
    this.fileloaded_callback && this.fileloaded_callback(event)
  }
  __handleProgress(event) {
    if (event.progress > 1) {
      return
    }
    if (this.progress_callback && this.state !== 'entry') {
      this.progress_callback(event)
    }
  }
  __handleFileProgress(event) {
    if (this.progress_callback && this.state !== 'entry') {
      this.progress_callback(event)
    }
  }
  __handleError(event) {
    this.error_callback && this.error_callback()
  }
  __handleComplete(event) {}
  __setFile(file) {
    let src = file
    if (typeof file == 'object') {
      src = file.src
    }
    if (this.srcArr.includes(src)) {
      return
    }
    this.srcArr.push(src)
    this.files.push(file)
  }
  __traverse(o, path) {
    let regExp = new RegExp(/\.(png|jpe?g|gif|svg|mp4)(\?.*)?$/)
    let type = typeof o
    let fullPath
    if (type === 'object') {
      for (var key in o) {
        if (typeof o[key] === 'string') {
          fullPath = path + o[key]
          if (o[key].search(regExp) != -1 && !this.preload.getItem(fullPath)) {
            this.__setFile({
              src: fullPath,
            })
          }
        } else {
          try {
            this.__traverse(o[key], path)
          } catch (e) {
            break
          }
        }
      }
    } else {
      fullPath = path + o
      if (
        type === 'string' &&
        o.search(regExp) != -1 &&
        !this.preload.getItem(fullPath)
      ) {
        this.__setFile({
          src: fullPath,
        })
      }
    }
  }
}
